import React from 'react';
import { Link } from 'react-router-dom';
import './Dashboard.css';

const RoadmapCard = ({
  title,
  slug,
  progress,
  stepsCompleted,
  totalSteps,
  projectTitle,
  projectLink
}) => {
  return (
    <div className="roadmap-card glossy-card">
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        <span className="status-chip in-progress">In Progress</span>
      </div>

      <div className="card-body">
        {/* Project Showcase Section */}
        {projectTitle && projectLink && (
          <p className="project-link-summary">
            Final Project:{" "}
            <a
              href={projectLink}
              target="_blank"
              rel="noopener noreferrer"
              className="auth-link"
            >
              {projectTitle}
            </a>
          </p>
        )}

        <p className="card-details">
          Progress: {stepsCompleted} / {totalSteps} steps completed
        </p>

        {/* Progress Bar */}
        <div className="progress-bar-container">
          <div
            className="progress-bar-fill"
            style={{ width: `${progress}%` }}
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>

      <div className="card-footer">
        <Link to={`/path/${slug}`} className="btn-secondary continue-btn">
          Continue Path &rarr;
        </Link>
      </div>
    </div>
  );
};

export default RoadmapCard;
